// The browser sends a form again on each click or Enter, even while the first request still runs.
// Two concurrent saves of the same record can conflict on the server, so a `data-submit-once` form
// ignores every submit after the first one.

const submitButtons = (form) => Array.from(form.elements).filter((element) => element.type === "submit");

const setButtonsDisabled = (form, disabled) => submitButtons(form).forEach((button) => (button.disabled = disabled));

export function submitOnce(event) {
  const form = event.target;
  if (event.defaultPrevented || !form.matches("[data-submit-once]")) return;

  if (form.dataset.submitting) {
    event.preventDefault();
    return;
  }

  form.dataset.submitting = "true";

  // Deferred so the clicked button still sends its name and value, and so a listener that runs
  // after this one and cancels the submit does not leave the form blocked.
  setTimeout(() => {
    if (event.defaultPrevented) {
      delete form.dataset.submitting;
      return;
    }
    setButtonsDisabled(form, true);
  }, 0);
}

export function releaseRestoredForms(event) {
  if (!event.persisted) return;

  document.querySelectorAll("form[data-submit-once]").forEach((form) => {
    delete form.dataset.submitting;
    setButtonsDisabled(form, false);
  });
}

document.addEventListener("submit", submitOnce);
window.addEventListener("pageshow", releaseRestoredForms);
